import React from 'react';

import { LANGUAGES } from '../../../constants';
import useLocalizedStrings from '../../../hooks/useLocalizedStrings';
import { PionType } from '../../../type';
import PionThumbnail from '../PionThumbnail';

import './pion-content-pdf.scss';

export const translations = {
  [LANGUAGES.EN]: {
    bookmarks: 'bookmarks',
    pages: 'pages',
  },
  [LANGUAGES.SV]: {
    bookmarks: 'bokmärken',
    pages: 'sidor',
  },
};

type PionPDFContentPropsType = {
  pion: PionType;
  lang: string;
};
const PionPDFContent = ({
  pion,
  lang = LANGUAGES.EN,
}: PionPDFContentPropsType) => {
  const file = pion.get('file');

  const strings = useLocalizedStrings(translations, lang);

  if (!file) {
    return null;
  }

  return (
    <div data-testid='pion-content-pdf' className='pion-content-pdf'>
      <div className='pion-content-pdf__thumbnail'>
        <PionThumbnail
          url={file.get('smallUrl')}
          caption={file.get('caption')}
        />
      </div>
      <div className='pion-content-pdf__info'>
        <div data-testid='title' className='pion-content-pdf__title'>
          {pion.get('documentName')}
        </div>
        <div>
          {!!file.get('bookmarks') && (
            <div data-testid='bookmarks' className='pion-content-pdf__text'>
              {file.get('bookmarks')} {strings.bookmarks}
            </div>
          )}
          <div data-testid='pages' className='pion-content-pdf__text'>
            {file.get('pages')} {strings.pages}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PionPDFContent;
